module.exports = __webpack_public_path__ + "img/2.30ada643.png";